/**
 * 一覧が0件
 */
export class NoListError extends Error {}
